
import { prop, Vue, Options } from "vue-class-component";
import Note from "./components/note.vue";
import SummarySTT from "./components/summary-stt.vue";
import { SummarySTTData, TicketDetail, TicketAction } from '@/domain/entities/PusatResolusiV2';
import DelDexCodrej from './components/del-dex-codrej.vue';
import PartnerSection from "./components/partner-section.vue";
import { CLIENT_ERROR, INTERNET_ERROR, INTERNAL_SERVER_ERROR } from '@/app/infrastructures/misc/Utils';
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import DetailItems from "./components/detail-items.vue";
import ModalFinishIssue from "./components/modal-finish-issue.vue";
import ModalSuccessFinish from "./components/modal-success-finish.vue";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import { FinishIssuePusatResolusiV2Request } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import IssueSection from "./components/issue-section.vue";
import { PusatResolusiV2Mapper } from '@/data/persistences/mappers/PusatResolusiV2Mapper';

class Props {
  data = prop<TicketDetail>({
    required: true
  });
  action = prop<TicketAction>({
    required: true
  });
  errorState = prop<string>({
    required: true
  });
  isLoading = prop<boolean>({
    required: true
  });
  websocket = prop<WebSocket>({
    required: true
  })
}

@Options({
  components: {
    Note,
    SummarySTT,
    DelDexCodrej,
    PartnerSection,
    Skeleton,
    DetailItems,
    ModalFinishIssue,
    ModalSuccessFinish,
    IssueSection
  },
  watch: {
    websocket: {
      handler(ws: WebSocket) {
        if (!ws) return;
        ws.addEventListener("message", async event => {
          const mapper = new PusatResolusiV2Mapper();
          const conversation = mapper.convertHistoryChatResponseFromWebsocket(event.data)[0];

          if (!conversation.type) {
            this.ticketAction = new TicketAction({
              isOpenMultipleTab: conversation.isOpenMultipleTab,
              isAssignedToOther: conversation.isAssignedToOther,
              assignedUsername: conversation.assignedUsername,
              action: conversation.action
            })
          };
        })
      }
    }
  }
})
export default class SummarySection extends Vue.with(Props) {
  CLIENT_ERROR = CLIENT_ERROR;
  INTERNAL_SERVER_ERROR = INTERNAL_SERVER_ERROR;
  INTERNET_ERROR = INTERNET_ERROR;
  activeTab = "summary";
  note = "";
  ticketAction = new TicketAction();

  get id() {
    return this.$route.params.id;
  }

  get issueNumber() {
    return this.data.ticket.caseNumber;
  }
  get partnerData() {
    return {
      reporter: {
        partnerCode: this.data.ticket.createdByPartnerCode,
        partnerName: this.data.ticket.createdByPartnerName,
        partnerUsername: this.data.ticket.createdByUsername,
        partnerTier: this.data.ticket.createdByTier.toLowerCase(),
        date: this.data.ticket.createdAt,
      },
      escalation: this.data.ticket.escalatePartner.map(partner => {
        return {
          partnerCode: partner.escalatePartnerCode,
          partnerName: partner.escalatePartnerName,
          partnerUsername: partner.escalatePartnerUsername,
          date: partner.escalateAt,
          type: partner.isYou ? "Anda" : "",
          finishAt: partner.escalateFinish
        }
      }),
      escalationBefore: this.data.ticket.escalatePartnerHistory.map(partner => {
        return {
          partnerCode: partner.escalatePartnerCode,
          partnerName: partner.escalatePartnerName,
          partnerUsername: partner.escalatePartnerUsername,
          date: partner.createdAt,
          type: partner.isYou ? "Anda" : "",
        }
      }),
      agent: {
        partnerCode: "",
        partnerName: this.data.ticket.agentCsId,
        partnerUsername: this.data.ticket.agentCsName,
        partnerFullname: this.data.ticket.agentCsName ?
            `Lion Parcel - ${this.data.ticket.agentCsName}` :
            '',
        date: this.data.ticket.agentCsAt
      },
      followers: this.data.ticket.followers.map(follower => {
        return {
          partnerCode: follower.accountPartnerCode,
          partnerName: follower.accountPartnerName,
          partnerUsername: follower.accountUsername,
          date: new Date(),
        }
      })
    }
  };
  
  get summaryDetailData() {
    return new SummarySTTData({
      bookingDate: this.data.summary.bookedAt,
      updatedAt: this.data.summary.lastStatusAt,
      sttNo: this.data.ticket.refNo,
      rejectReason: this.data.summary.lastDelivReasonName,
      productType: this.data.summary.product,
      posName: this.data.summary.bookedName,
      posLevel: this.data.summary.bookedTier.toLowerCase(),
      origin: this.data.summary.originCity,
      destination: this.data.summary.destinationCity,
      lastStatus: this.data.summary.lastStatus,
      isOnSLA: this.data.summary.isSla,
      isDFOD: this.data.summary.isDfod,
      isCOD: this.data.summary.isCod,
      estimationDate: this.data.summary.estimatedSlaEndDate,
      dexAttemps: this.data.summary.totalDexAttempt,
      delAttemps: this.data.summary.totalDelAttempt,
      codRejAttemps: this.data.summary.totalCodrejattempt,
      courierName: this.data.summary.lastDelivCourierName,
      lastDelivPartnerName: this.data.summary.lastDelivPartnerName,
      lastDelivAt: this.data.summary.lastDelivAt
    })
  }

  get isDelDexCodrej() {
    const validLabels = ["Permintaan Penarikan Paket", "Paket Gagal Antar", "Sanggah Terima"];
    const validStatuses = ["DEL", "DEX", "CODREJ"]

    return (
      validLabels.map(label => label.toLowerCase()).includes(this.data.ticket.category.label.toLowerCase()) &&
      validStatuses.map(status => status.toLowerCase()).includes(this.data.summary.lastStatus.toLowerCase())
    );
  }

  get isShowNote() {
    return this.action.action.includes("note");
  }

  get isShowSolveTicketButton() {
    return this.action.action.includes("solve_ticket");
  }

  onSubmitNote() {
    // implement submit note integration here
  }
  // modal finish
  modalFinish = false;
  modalSuccessFinish = false;
  onShowModalFinish() {
    this.modalFinish = !this.modalFinish;
  }
  onShowModalSuccessFinish() {
    this.modalSuccessFinish = !this.modalSuccessFinish;
  }

  resetValueChat() {
    PusatResolusiV2Controller.setChatMessageFinish("");
    PusatResolusiV2Controller.setMentionSelectedFinish([]);
    PusatResolusiV2Controller.setUploadedFilesFinish([]);
  }

  async onSubmitFinish() {
    this.modalFinish = false;
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();

    try {
      const finish = await PusatResolusiV2Controller.finishTicket({
        id: Number(this.id),
        // fill payload when work on ticket chat component
        payload: new FinishIssuePusatResolusiV2Request({
          message: PusatResolusiV2Controller.chatMessageFinish,
          mentions: JSON.stringify(PusatResolusiV2Controller.mentionSelectedFinish),
          attachments: PusatResolusiV2Controller.uploadedFilesFinish.filter((e): e is File => e !== null)
        })
      });
      if (finish) {
        this.onShowModalSuccessFinish();
        this.resetValueChat();
      }
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          "Gagal meneyelesaikan kendala!",
          this.onSubmitFinish,
          this.resetValueChat
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
}
